// Workplace inbox + calendar, mounted inside the shared attention panel
// so float mode does not need a second bell panel.
import { useEffect } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { useWorkplaceMessagesState } from "@/components/messages/useWorkplaceMessagesState";
import { WorkplaceActivityNotificationsSection } from "@/components/messages/WorkplaceActivityNotificationsSection";
import { ActivityBannerGoogleCalendarSection } from "@/components/shell/popovers/ActivityBannerGoogleCalendarSection";

export function AttentionMessageInbox(props: { onClosePanel?: () => void }) {
  const auth = useAuth();
  const wp = useWorkplaceMessagesState();
  const loadOnOpen = wp.loadOnOpen;
  useEffect(() => {
    loadOnOpen();
  }, [loadOnOpen]);

  if (wp.capable === false) return null;

  const allow = auth.hasRole(
    "trainer",
    "marketing",
    "admin",
    "owner",
    "dev",
    "ads_guidance_editor",
    "platform_owner",
    "platform_admin",
    "platform_dev",
    "platform_trainer",
  );

  return (
    <section className="mt-3" aria-label="Messages">
      <h3 className="px-0.5 text-[10px] font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">
        Messages
      </h3>
      <div className="mt-2">
        <WorkplaceActivityNotificationsSection
          wpState={wp}
          allowTestNotification={auth.hasRole("admin", "owner", "dev", "platform_admin", "platform_dev")}
          allowSenderLock={allow}
          allowRequiresAck={allow}
          panelOpen
          onClosePanel={props.onClosePanel}
        />
        <ActivityBannerGoogleCalendarSection open />
      </div>
    </section>
  );
}
